import {
  CARD_ADD,
  CARD_ADD_SUCCESS,
  CARD_ADD_ERROR,
  CARD_PATCH,
  CARD_PATCH_SUCCESS,
  CARD_PATCH_ERROR,
  CARD_MEDIA_ADD,
  CARD_MEDIA_ADD_SUCCESS,
  CARD_MEDIA_ADD_ERROR,
  CARD_LINK_ADD,
  CARD_LINK_ADD_SUCCESS,
  CARD_LINK_ADD_ERROR,
  CARD_SELECTION_ADD,
  CARD_SELECTION_ADD_SUCCESS,
  CARD_SELECTION_ADD_ERROR,
  CARD_MEDIA_DELETE,
  CARD_MEDIA_DELETE_SUCCESS,
  CARD_MEDIA_DELETE_ERROR,
  CARD_LINK_DELETE,
  CARD_LINK_DELETE_SUCCESS,
  CARD_LINK_DELETE_ERROR,
  CARD_SELECTION_DELETE,
  CARD_SELECTION_DELETE_SUCCESS,
  CARD_SELECTION_DELETE_ERROR,
  CARD_SELECTION_PATCH,
  CARD_SELECTION_PATCH_SUCCESS,
  CARD_SELECTION_PATCH_ERROR,
  GET_BADGES,
  GET_BADGES_SUCCESS,
  GET_BADGES_ERROR,
  COURSE_REMOVE_CARD,
  COURSE_REMOVE_CARD_SUCCESS,
  COURSE_REMOVE_CARD_ERROR,
  CARD_SETTING_PATCH,
  CARD_SETTING_PATCH_SUCCESS,
  CARD_SETTING_PATCH_ERROR,
  CARD_SETTING_CREATE,
  CARD_SETTING_CREATE_SUCCESS,
  CARD_SETTING_CREATE_ERROR,
  CARD_SETTING_REMOVE,
  COURSE_CARD_LINK_PATCH,
  COURSE_CARD_LINK_PATCH_SUCCESS,
  COURSE_CARD_LINK_PATCH_ERROR,
  CARD_CHANGE_IMAGE,
  DELETE_SECTION,
  DELETE_SECTION_SUCCESS,
  DELETE_SECTION_ERROR,
  GET_CARD,
  GET_CARD_SUCCESS,
  GET_CARD_ERROR,
  EDITOR_LOADING,
} from './type'

/**
 *
 * @param {*} entity
 * @param {*} callback
 */
export const cardAddAction = (entity, courseId, callback) => {
  return {
    type: CARD_ADD,
    payload: { entity, courseId, callback },
  }
}

/**
 *
 * @param {*} entity
 */
export const cardAddSuccess = entity => {
  return {
    type: CARD_ADD_SUCCESS,
    payload: { entity },
  }
}

/**
 *
 */
export const cardAddError = () => {
  return {
    type: CARD_ADD_ERROR,
  }
}

/**
 *
 * @param {*} content
 * @param {*} callback
 */
export const cardPatchAction = (content, callback) => {
  return {
    type: CARD_PATCH,
    payload: { content, callback },
  }
}

/**
 *
 * @param {*} content
 */
export const cardPatchSuccess = content => {
  return {
    type: CARD_PATCH_SUCCESS,
    payload: { content },
  }
}

/**
 *
 */
export const cardPatchError = () => {
  return {
    type: CARD_PATCH_ERROR,
  }
}

/**
 *
 * @param {*} entity
 * @param {*} callback
 */
export const cardMediaAddAction = (entity, callback) => {
  return {
    type: CARD_MEDIA_ADD,
    payload: { entity, callback },
  }
}

/**
 *
 * @param {*} entity
 */
export const cardMediaAddSuccess = entity => {
  return {
    type: CARD_MEDIA_ADD_SUCCESS,
    payload: { entity },
  }
}

/**
 *
 */
export const cardMediaAddError = () => {
  return {
    type: CARD_MEDIA_ADD_ERROR,
  }
}

/**
 *
 * @param {*} entity
 * @param {*} callback
 */
export const cardLinkAddAction = (entity, callback) => {
  return {
    type: CARD_LINK_ADD,
    payload: { entity, callback },
  }
}

/**
 *
 */
export const cardLinkAddSuccess = entity => {
  return {
    type: CARD_LINK_ADD_SUCCESS,
    payload: { entity },
  }
}

/**
 *
 */
export const cardLinkAddError = () => {
  return {
    type: CARD_LINK_ADD_ERROR,
  }
}
/**
 *
 * @param {*} entity
 * @param {*} callback
 */
export const cardSelectionAddAction = (entity, callback) => {
  return {
    type: CARD_SELECTION_ADD,
    payload: { entity, callback },
  }
}

/**
 *
 * @param {*} response
 */
export const cardSelectionAddSuccess = response => {
  return {
    type: CARD_SELECTION_ADD_SUCCESS,
    payload: { response },
  }
}

/**
 *
 */
export const cardSelectionAddError = () => {
  return {
    type: CARD_SELECTION_ADD_ERROR,
  }
}

/**
 *
 * @param {*} id
 * @param {*} callback
 */
export const cardMediaDeleteAction = (id, questionId, callback) => {
  return {
    type: CARD_MEDIA_DELETE,
    payload: { id, questionId, callback },
  }
}

/**
 *
 */
export const cardMediaDeleteSuccess = id => {
  return {
    type: CARD_MEDIA_DELETE_SUCCESS,
    payload: { id },
  }
}

/**
 *
 */
export const cardMediaDeleteError = () => {
  return {
    type: CARD_MEDIA_DELETE_ERROR,
  }
}

/**
 *
 * @param {*} id
 * @param {*} callback
 */
export const cardLinkDeleteAction = (id, questionId, callback) => {
  return {
    type: CARD_LINK_DELETE,
    payload: { id, questionId, callback },
  }
}

/**
 *
 * @param {*} response
 */
export const cardLinkDeleteSuccess = response => {
  return {
    type: CARD_LINK_DELETE_SUCCESS,
    payload: { response },
  }
}

/**
 *
 */
export const cardLinkDeleteError = () => {
  return {
    type: CARD_LINK_DELETE_ERROR,
  }
}

/**
 *
 * @param {*} id
 * @param {*} callback
 */
export const cardSelectionDeleteAction = (id, questionId, callback) => {
  return {
    type: CARD_SELECTION_DELETE,
    payload: { id, questionId, callback },
  }
}

/**
 *
 * @param {*} id
 * @param {*}  questionId
 */
export const cardSelectionDeleteSuccess = (id, questionId) => {
  return {
    type: CARD_SELECTION_DELETE_SUCCESS,
    payload: { id, questionId },
  }
}

/**
 *
 */
export const cardSelectionDeleteError = () => {
  return {
    type: CARD_SELECTION_DELETE_ERROR,
  }
}

/**
 *
 * @param {*} content
 * @param {*} callback
 */
export const cardSelectionPatchAction = (content, questionId, callback) => {
  return {
    type: CARD_SELECTION_PATCH,
    payload: { content, questionId, callback },
  }
}

/**
 *
 * @param {*} content
 */
export const cardSelectionPatchSuccess = (content, questionId) => {
  return {
    type: CARD_SELECTION_PATCH_SUCCESS,
    payload: { content, questionId },
  }
}

/**
 *
 */
export const cardSelectionPatchError = () => {
  return {
    type: CARD_SELECTION_PATCH_ERROR,
  }
}

/**
 *
 */

export const getBadgesAction = callback => {
  return {
    type: GET_BADGES,
    payload: { callback },
  }
}

/**
 *
 * @param {*} response
 */
export const getBadgesSuccess = response => {
  return {
    type: GET_BADGES_SUCCESS,
    payload: { response },
  }
}

/**
 *
 */
export const getBadgesError = () => {
  return {
    type: GET_BADGES_ERROR,
  }
}

export const courseRemoveCard = (courseId, cardId, callback) => {
  return {
    type: COURSE_REMOVE_CARD,
    payload: { cardId, courseId, callback },
  }
}

export const courseRemoveCardSuccess = (cardId, callback) => {
  return {
    type: COURSE_REMOVE_CARD_SUCCESS,
    payload: { cardId, callback },
  }
}

export const courseRemoveCardError = () => {
  return {
    type: COURSE_REMOVE_CARD_ERROR,
  }
}

export const cardSettingPatch = (
  content,
  settingId,
  questionId,
  key,
  callback,
) => {
  return {
    type: CARD_SETTING_PATCH,
    payload: { content, settingId, questionId, key, callback },
  }
}

export const cardSettingPatchSuccess = (
  content,
  settingId,
  key,
  questionId,
) => {
  return {
    type: CARD_SETTING_PATCH_SUCCESS,
    payload: { content, settingId, key, questionId },
  }
}

export const cardSettingPatchError = () => {
  return {
    type: CARD_SETTING_PATCH_ERROR,
  }
}

export const cardSettingCreate = (content, questionId, callback) => {
  return {
    type: CARD_SETTING_CREATE,
    payload: { content, questionId, callback },
  }
}

export const cardSettingCreateSuccess = (content, questionId) => {
  return {
    type: CARD_SETTING_CREATE_SUCCESS,
    payload: { content, questionId },
  }
}

export const cardSettingCreateError = () => {
  return {
    type: CARD_SETTING_CREATE_ERROR,
  }
}

export const cardSettingRemove = (questionId, id) => {
  return {
    type: CARD_SETTING_REMOVE,
    payload: { questionId, id },
  }
}

//card reducer must be added
export const courseCardLinkPatchAction = (content, cardId, callback) => {
  return {
    type: COURSE_CARD_LINK_PATCH,
    payload: { content, cardId, callback },
  }
}

/**
 *
 * @param {*} content
 */
export const courseCardLinkPatchSuccess = (content, cardId) => {
  return {
    type: COURSE_CARD_LINK_PATCH_SUCCESS,
    payload: { content, cardId },
  }
}

/**
 *
 */
export const courseCardLinkPatchError = () => {
  return {
    type: COURSE_CARD_LINK_PATCH_ERROR,
  }
}

/**
 *
 * @param {*} cardId
 * @param {*} imageUrl
 * @param {*} callback
 */
export const cardChangeImageAction = (cardId, imageUrl, callback) => {
  return {
    type: CARD_CHANGE_IMAGE,
    payload: { cardId, imageUrl, callback },
  }
}

export const deleteSectionAction = (id, callback) => {
  return {
    type: DELETE_SECTION,
    payload: { id, callback },
  }
}

export const deleteSectionSuccess = id => {
  return {
    type: DELETE_SECTION_SUCCESS,
    payload: { id },
  }
}

export const deleteSectionError = () => {
  return {
    type: DELETE_SECTION_ERROR,
  }
}

export const getCardAction = (id, callback) => {
  return {
    type: GET_CARD,
    payload: { id, callback },
  }
}

export const getCardSuccess = response => {
  return {
    type: GET_CARD_SUCCESS,
    payload: { response },
  }
}

export const getCardError = () => {
  return {
    type: GET_CARD_ERROR,
  }
}

export const editorLoading = error => {
  return {
    type: EDITOR_LOADING,
    payload: { error },
  }
}
